/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type YardTypeEnum = (typeof YardTypeEnum)[keyof typeof YardTypeEnum];

export const YardTypeEnum = {
  none: 'none',
  fenced: 'fenced',
  unfenced: 'unfenced',
} as const;
